<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createContenidoEntregable"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetSendingOfDeliverablesModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="entregable.entregable.asunto"
          :inputError="$v.entregable.entregable.asunto.$error"
          :label="$t('mEditionAssetSendingOfDeliverablesModalCreate.inputs.asunto.label')"
          :message="$t('mEditionAssetSendingOfDeliverablesModalCreate.inputs.asunto.message')"
          :messageError="messageErrorAsunto"
          name="asunto"
          type="text"
          @blur="$v.entregable.entregable.asunto.$touch()"
        />

        <AtomTextAreaPrimary
          v-model="entregable.entregable.mensaje"
          :inputError="$v.entregable.entregable.mensaje.$error"
          :label="$t('mEditionAssetSendingOfDeliverablesModalCreate.inputs.mensaje.label')"
          :messageError="messageErrorMensaje"
          name="mensaje"
          rows="8"
          @blur="$v.entregable.entregable.mensaje.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetSendingOfDeliverablesModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'mEditionAssetSendingOfDeliverablesModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetSendingOfDeliverablesModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      entregable: {
        academia: '',
        entregable: {
          asunto: '',
          mensaje: '',
          dia: ''
        }
      }
    }
  },

  validations: {
    entregable: {
      entregable: {
        asunto: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        },

        mensaje: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorAsunto () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesModalCreate', this.$v.entregable.entregable.asunto, 'asunto')
    },

    messageErrorMensaje () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesModalCreate', this.$v.entregable.entregable.mensaje, 'mensaje')
    }
  },

  created () {
    this.entregable.academia = this.$store.getters.getAcademyData.id
    this.entregable.entregable.dia = this.$modal.element.dia
  },

  methods: {
    createContenidoEntregable () {
      this.$v.$touch()
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('contenido', 'createContenidoEntregable', this.entregable, [this.$modal.element.version])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalCreate', 'createContenidoEntregable', 'success')
            this.buttonPrimary.sending = false
            this.$modal.closeModal()
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalCreate', 'createContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
